var _path, _circle, _polygon, _polygon2, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    height: "2em",
    width: "2em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8CBCD6",
    d: "M40,41H8c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v26C44,39.2,42.2,41,40,41z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#B3DDF5",
    cx: 35,
    cy: 16,
    r: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9AC9E3",
    points: "20,16 9,32 31,32"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B3DDF5",
    points: "31,22 23,32 39,32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F44336",
    cx: 38,
    cy: 38,
    r: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 32,
    transform: "matrix(-.707 .707 -.707 -.707 91.74 38)",
    width: 3,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 32,
    transform: "matrix(-.707 -.707 .707 -.707 38 91.74)",
    width: 3,
    height: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.04271fac2d25e587b6fc9bf627998048.svg";
export { ForwardRef as ReactComponent };